import { FileDownload } from '@mui/icons-material';
import { Button } from '@mui/material';
import { GridFooter, GridFooterContainer } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetterEveryword } from 'shared/stringFunctions';
import { TXT_DOWNLOAD } from '../../../../../shared/translations';

export interface DownloadFooterProps {
  onDownload?: () => void;
  isGridFooter?: boolean;
  disabled?: boolean;
}

export const DownloadButton = (props: DownloadFooterProps) => {
  const { t } = useTranslation();

  const renderPlainButton = (): JSX.Element => (
    <Button
      variant="contained"
      color="primary"
      startIcon={<FileDownload />}
      onClick={props.onDownload}
      disabled={props.disabled}
    >
      {capitalizeFirstLetterEveryword(t(TXT_DOWNLOAD))}
    </Button>
  );

  const renderFooterWithButton = () => (
    <GridFooterContainer
      sx={(theme) => ({
        padding: `0 ${theme.spacing(1)}`,
        display: 'flex',
        justifyContent: !!props.onDownload ? 'space-between' : 'flex-end',
        alignItems: 'center'
      })}
    >
      {!!props.onDownload && renderPlainButton()}
      <GridFooter
        sx={{
          border: 'none'
        }}
      />
    </GridFooterContainer>
  );

  return <div>{!props.isGridFooter ? renderPlainButton() : renderFooterWithButton()}</div>;
};
